import { SET_ADMIN_DATA, SET_SELECTED_MAILING } from '../type';

const adminReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case SET_ADMIN_DATA:
      const { data, stateName } = payload;
      return {
        ...state,
        [stateName]: data,
      };
    // adding flag selected to chosen mailing and deleting it from other mailings
    case SET_SELECTED_MAILING:
      return {
        ...state,
        data: {
          ...state.data,
          mailings: state?.data?.mailings?.map((item) => ({
            ...item,
            selected: item.key_name === payload,
          })),
        },
      };
    default:
      return state;
  }
};

export default adminReducer;
